import api from './axios';

// --- Organizasyon (Fibonacci, FLL Explore, Robotex...) ---
export const getCompetitionOrganizations = (params) => api.get('/competition-organizations', { params });
export const createCompetitionOrganization = (data) => api.post('/competition-organizations', data);
export const updateCompetitionOrganization = (id, data) => api.put(`/competition-organizations/${id}`, data);
export const deleteCompetitionOrganization = (id) => api.delete(`/competition-organizations/${id}`);

// --- Yarışma (yıl bazlı: "Fibonacci 2026") ---
export const getCompetitions = (params) => api.get('/competitions', { params });
export const getCompetitionYears = () => api.get('/competitions/years');
export const getCompetition = (id) => api.get(`/competitions/${id}`);
export const createCompetition = (data) => api.post('/competitions', data);
export const updateCompetition = (id, data) => api.put(`/competitions/${id}`, data);
export const deleteCompetition = (id) => api.delete(`/competitions/${id}`);

// --- Etap (İzmir / İstanbul / Roma) ---
export const getStages = (competitionId) => api.get(`/competitions/${competitionId}/stages`);
export const getStage = (id) => api.get(`/competition-stages/${id}`);
export const createStage = (competitionId, data) => api.post(`/competitions/${competitionId}/stages`, data);
export const updateStage = (id, data) => api.put(`/competition-stages/${id}`, data);
export const deleteStage = (id) => api.delete(`/competition-stages/${id}`);
export const copyFromStage = (id, data) => api.post(`/competition-stages/${id}/copy-from`, data);

// --- Proje havuzu (yarışmadan bağımsız) ---
export const getCompetitionProjects = (params) => api.get('/competition-projects', { params });
export const getCompetitionProject = (id) => api.get(`/competition-projects/${id}`);
export const createCompetitionProject = (data) => api.post('/competition-projects', data);
export const updateCompetitionProject = (id, data) => api.put(`/competition-projects/${id}`, data);
export const deleteCompetitionProject = (id) => api.delete(`/competition-projects/${id}`);

// --- Takım ---
export const getTeams = (competitionId, params) => api.get(`/competitions/${competitionId}/teams`, { params });
export const createTeam = (competitionId, data) => api.post(`/competitions/${competitionId}/teams`, data);
export const updateTeam = (id, data) => api.put(`/competition-teams/${id}`, data);
export const deleteTeam = (id) => api.delete(`/competition-teams/${id}`);
export const getStageTeams = (stageId) => api.get(`/competition-stages/${stageId}/teams`);
export const attachTeamToStage = (stageId, data) => api.post(`/competition-stages/${stageId}/teams`, data);
export const updateStageTeam = (id, data) => api.put(`/competition-stage-teams/${id}`, data);
export const detachTeamFromStage = (id) => api.delete(`/competition-stage-teams/${id}`);

// --- Katılımcı ---
export const getParticipants = (stageId, params) => api.get(`/competition-stages/${stageId}/participants`, { params });
export const getCandidateStudents = (stageId, params) => api.get(`/competition-stages/${stageId}/candidate-students`, { params });
export const addParticipants = (stageId, data) => api.post(`/competition-stages/${stageId}/participants`, data);
export const updateParticipant = (id, data) => api.put(`/competition-participants/${id}`, data);
export const updateParticipantStatus = (id, data) => api.patch(`/competition-participants/${id}/status`, data);
// Katilim/ucret onayini YONETICI olarak elle degistirir. `status`tan AYRI
// bir uc: orada onaylar duruma bagli degisiyor ve geri alinamiyordu.
// Sunucu bu yolla yazildiginda IP/cihaz izini SILIYOR - veli beyani ile
// yonetici kaydi oyle ayirt ediliyor.
export const updateParticipantConsent = (id, data) => api.patch(`/competition-participants/${id}/consent`, data);
// Etaptaki TUM katilimcilari onayli + kesinlesmis yapar. Veli acikca
// REDDETMIS olanlari ve iptal edilmisleri ATLAR - toplu bir dugme bir
// velinin beyanini sessizce tersine cevirmemeli.
export const bulkApproveParticipants = (stageId) => api.post(`/competition-stages/${stageId}/participants/bulk-approve`);
export const deleteParticipant = (id) => api.delete(`/competition-participants/${id}`);

// --- Ücret ve taksit ---
export const getFeeItems = (stageId) => api.get(`/competition-stages/${stageId}/fee-items`);
export const createFeeItem = (stageId, data) => api.post(`/competition-stages/${stageId}/fee-items`, data);
export const updateFeeItem = (id, data) => api.put(`/competition-fee-items/${id}`, data);
export const deleteFeeItem = (id) => api.delete(`/competition-fee-items/${id}`);
export const getInstallmentPlan = (stageId) => api.get(`/competition-stages/${stageId}/installment-plan`);
export const createInstallmentPlanItem = (stageId, data) => api.post(`/competition-stages/${stageId}/installment-plan`, data);
export const updateInstallmentPlanItem = (id, data) => api.put(`/competition-installment-plan-items/${id}`, data);
export const deleteInstallmentPlanItem = (id) => api.delete(`/competition-installment-plan-items/${id}`);
export const getParticipantFees = (participantId) => api.get(`/competition-participants/${participantId}/fees`);
export const applyParticipantFees = (participantId, data) => api.post(`/competition-participants/${participantId}/fees/apply`, data);
// `overwrite` YALNIZCA mevcut planin silinecegi onaylandiktan sonra
// gonderilir (StageFinanceTab -> planUret). Toplu ucta boyle bir bayrak YOK.
export const generateInstallments = (participantId, govde) =>
  api.post(`/competition-participants/${participantId}/installments/generate`, govde);
// Plani etaptaki herkese tek seferde uygular; tahsilati olanlar atlanir.
export const generateInstallmentsForAll = (stageId) => api.post(`/competition-stages/${stageId}/installments/generate-all`);
export const getInstallments = (participantId) => api.get(`/competition-participants/${participantId}/installments`);
export const createInstallment = (participantId, data) => api.post(`/competition-participants/${participantId}/installments`, data);
export const updateInstallment = (id, data) => api.put(`/competition-installments/${id}`, data);
// Kismi tahsilat: tutar gonderilmezse kalanin tamami tahsil edilmis sayilir.
export const payInstallment = (id, data) => api.patch(`/competition-installments/${id}/pay`, data);
// Taksitin TUM tahsilatlarini geri alir.
export const unpayInstallment = (id) => api.patch(`/competition-installments/${id}/unpay`);
// Tek bir tahsilat kaydini siler (yanlis girilen odeme).
export const deleteInstallmentPayment = (paymentId) => api.delete(`/competition-installment-payments/${paymentId}`);
export const deleteInstallment = (id) => api.delete(`/competition-installments/${id}`);

// ASILI KALMIS TAHSILAT: silinmis taksite bagli, hala canli odeme satirlari.
// Neredeyse her zaman BOS doner; dolu donerse o para hicbir ekranda
// gorunmuyor demektir (bkz. backend/CLAUDE.md "Kusur 3").
export const getOrphanedInstallments = (participantId) =>
  api.get(`/competition-participants/${participantId}/orphaned-installments`);
export const getFinanceSummary = (stageId) => api.get(`/competition-stages/${stageId}/finance-summary`);

// --- Belgeler ---
export const getDocumentTypes = () => api.get('/competition-document-types');
export const createDocumentType = (data) => api.post('/competition-document-types', data);
export const updateDocumentType = (id, data) => api.put(`/competition-document-types/${id}`, data);
export const deleteDocumentType = (id) => api.delete(`/competition-document-types/${id}`);
export const getDocuments = (stageId, params) => api.get(`/competition-stages/${stageId}/documents`, { params });
export const updateDocument = (id, data) => api.put(`/competition-documents/${id}`, data);
export const deleteDocument = (id) => api.delete(`/competition-documents/${id}`);

// Dosya yüklerken Content-Type'ı axios'un kendisi (boundary ile birlikte)
// belirlemeli; instance'ın application/json varsayılanı burada geçersiz
// kılınıyor, aksi halde backend dosyayı hiç görmez.
export const uploadDocument = (stageId, formData) =>
  api.post(`/competition-stages/${stageId}/documents`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });

// --- Yarışma geneli belge ve notlar (etap gerekmez) ---
// Yönetici yarışmayı tanımladıktan sonra, daha hiç etap yokken de şartname/
// yazışma biriktirebilmeli. Bu belgeler veliye AÇILMAZ (yönetim evrakı).
export const getCompetitionDocuments = (competitionId, params) =>
  api.get(`/competitions/${competitionId}/documents`, { params });

export const uploadCompetitionDocument = (competitionId, formData) =>
  api.post(`/competitions/${competitionId}/documents`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });

export const getCompetitionNotes = (competitionId, params) =>
  api.get(`/competitions/${competitionId}/notes`, { params });
export const createCompetitionNote = (competitionId, data) =>
  api.post(`/competitions/${competitionId}/notes`, data);
export const updateCompetitionNote = (id, data) => api.put(`/competition-notes/${id}`, data);
export const deleteCompetitionNote = (id) => api.delete(`/competition-notes/${id}`);

// --- Pasaport / katılacak kişiler ---
export const getTravelers = (stageId, params) => api.get(`/competition-stages/${stageId}/travelers`, { params });
export const createTraveler = (stageId, data) => api.post(`/competition-stages/${stageId}/travelers`, data);
export const updateTraveler = (id, data) => api.put(`/competition-travelers/${id}`, data);
export const deleteTraveler = (id) => api.delete(`/competition-travelers/${id}`);
// Excel: Turkce Windows'ta Excel'in liste ayraci noktali virgul oldugu icin
// virgullu CSV tek sutuna aciliyor. Aracci firmaya gonderilen liste sutunlara
// ayrilmis olmali - xlsx yerel ayardan bagimsiz calisir.
export const exportTravelersExcel = (stageId) =>
  api.get(`/competition-stages/${stageId}/travelers/export-excel`, { responseType: 'blob' });
export const exportTravelersCsv = (stageId) =>
  api.get(`/competition-stages/${stageId}/travelers/export`, { responseType: 'blob' });

// --- Çalışmalar ve yönetici görevleri ---
export const getWorkSessions = (stageId, params) => api.get(`/competition-stages/${stageId}/work-sessions`, { params });
export const createWorkSession = (stageId, data) => api.post(`/competition-stages/${stageId}/work-sessions`, data);
export const updateWorkSession = (id, data) => api.put(`/competition-work-sessions/${id}`, data);
export const deleteWorkSession = (id) => api.delete(`/competition-work-sessions/${id}`);
export const getAdminTasks = (stageId) => api.get(`/competition-stages/${stageId}/admin-tasks`);
export const createAdminTask = (stageId, data) => api.post(`/competition-stages/${stageId}/admin-tasks`, data);
export const updateAdminTask = (id, data) => api.put(`/competition-admin-tasks/${id}`, data);
export const deleteAdminTask = (id) => api.delete(`/competition-admin-tasks/${id}`);

// --- Veliye bildirim gönderme ---
export const notifyInvitations = (stageId, data) => api.post(`/competition-stages/${stageId}/notify/invitations`, data);
export const notifyFeeApprovals = (stageId, data) => api.post(`/competition-stages/${stageId}/notify/fee-approvals`, data);
export const notifyPassportRequest = (stageId, data) => api.post(`/competition-stages/${stageId}/notify/passport-request`, data);
export const notifyDocument = (documentId) => api.post(`/competition-documents/${documentId}/notify`);

// --- Veli tarafı ---
export const getParentCompetitions = () => api.get('/parent/competitions');
export const getParentCompetition = (participantId, params) => api.get(`/parent/competitions/${participantId}`, { params });
export const sendParticipationConsent = (participantId, data) => api.post(`/parent/competitions/${participantId}/participation-consent`, data);
export const sendFeeConsent = (participantId, data) => api.post(`/parent/competitions/${participantId}/fee-consent`, data);
export const getParentTravelers = (participantId) => api.get(`/parent/competitions/${participantId}/travelers`);
export const createParentTraveler = (participantId, data) => api.post(`/parent/competitions/${participantId}/travelers`, data);
export const updateParentTraveler = (id, data) => api.put(`/parent/competition-travelers/${id}`, data);
export const deleteParentTraveler = (id) => api.delete(`/parent/competition-travelers/${id}`);

// --- Bankoda yarisma tahsilati -------------------------------------------
//
// DAR izin (`competitions.payments`) ile calisir; `competitions.finance`
// DEGIL - o izin yarismanin tum parasini acardi. Akis ogrenci odakli:
// ogretmen hangi ogrencinin hangi etapta oldugunu bilmiyor, once ogrenci
// araniyor.
export const searchCompetitionPayStudents = (search) =>
  api.get('/competition-payments/students', { params: { search } });

// Hem banko ekrani hem ogrenci detayindaki SALT OKUNUR "Yarismalar"
// sekmesi burayi kullaniyor - tek kaynak, iki yuzey.
export const getStudentCompetitions = (studentId) =>
  api.get(`/students/${studentId}/competitions`);

// Yonetici olmayan YALNIZCA bugune girebilir; kapi sunucuda.
export const collectCompetitionInstallment = (installmentId, data) =>
  api.post(`/competition-installments/${installmentId}/collect`, data);

// GUN SONU MUTABAKATI - "bugun kim ne odedi, ne kadar topladik".
//
// KAPSAMI SUNUCU BELIRLIYOR, istemci degil: yanittaki scope alani
// competitions.finance olanda "all" (subenin tamami), olmayanda "own"
// (yalnizca kendi tahsilati). Arayuz o alana bakip metni ayarliyor -
// received_by gondererek baskasinin satirini cekmek MUMKUN DEGIL.
export const getCompetitionCollections = (params) =>
  api.get("/competition-payments/collections", { params });
